<template>
    <div class="animated fadeIn vld-parent custom-100">
        <b-row>
            <b-col sm="12">
                <searchBar ref="searchBar" :user-groups="userGroups"
                           :augrs="augrs" :user-group-select="userGroupSelect"
                           :augr-select="augrSelect" :on-search="queryData"></searchBar>
            </b-col>
        </b-row>
        <b-row class="custom-flex-1">
            <b-col sm="12">
                <auftraegeTable ref="auftraegeTable"
                                :table-data="data" :show-freigabe="settings.fg_stufe1"
                                :all-groups="allGroups" :is-encrypted="isEncrypted"></auftraegeTable>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import searchBar from './searchbar'
    import auftraegeTable from './AuftragTable'
    import {Redirect_500, Redirect_Login, Server_URL} from "../../shared/utils";

    export default {
        name: "Auftraege_Offen",
        components: {'searchBar':searchBar, 'auftraegeTable': auftraegeTable},
        data() {
            return {
                loader: undefined,
                // SearchbarProps
                userGroups: [],
                userGroupSelect: undefined,
                augrs: [],
                augrSelect: undefined,
                data: [],
                currentPage: 1,
                settings: {fg_stufe1: false},
                isEncrypted: false,
                allGroups: [],
            }
        },
        created() {
            this.isEncrypted = sessionStorage.getItem("aes") !== null;
            this.showLoader();
            this.$http.get(
                Server_URL+'/auftragsbuch/data/fetch'
            ).then(this.responseOkGet, this.responseError)
        },
        methods: {

            showLoader() {
                this.loader = this.$loading.show();
            },
            hideLoader() {
                if (this.loader !== undefined) {
                    this.loader.hide();
                    this.loader = undefined;
                }
            },
            responseOkGet(response) {
                this.hideLoader();
                if (response.status === 200 && response.body.status === "ok") {
                    let groups = response.body.data.groups;
                    let augr = response.body.data.augrs;
                    let module_groups = response.body.data.module_groups;
                    if (!this.isEncrypted) {
                        this.userGroups.push({text: "Alle", value: -1});
                        this.userGroupSelect = -1;
                        for (let i = 0; i < groups.length; i++) {
                            let res = JSON.parse(sessionStorage.getItem(groups[i].name));
                            if (res !== null) {
                                this.userGroups.push({text: res.username, value: groups[i].id});
                            } else {
                                this.userGroups.push({text: groups[i].name, value: groups[i].id});
                            }
                        }
                    } else {
                        this.userGroups.push({text: "Alle", value: {id: "all", module: "all"}});
                        this.userGroupSelect = {id: "all", module: "all"};
                        for (let i = 0; i < module_groups.length; i++) {
                            let res = JSON.parse(sessionStorage.getItem(module_groups[i].name));
                            if (res !== null) {
                                this.userGroups.push({text: res.username, value: module_groups[i]});
                            } else {
                                switch (module_groups[i].module) {
                                    case "ab":
                                        module_groups[i].name += " (Auftragsbuch)";
                                        break;
                                    case "mm":
                                        module_groups[i].name += " (Mängelmelder)";
                                        break;
                                }
                                this.userGroups.push({text: module_groups[i].name, value: module_groups[i]});
                            }
                        }
                    }
                    this.allGroups = response.body.data.all_groups;
                    for (let i = 0; i < augr.length; i++) {
                        this.augrs.push({text: augr[i].titel, value: augr[i].key});
                        if (i === 0) {
                            this.augrSelect = augr[i].key;
                        }
                    }
                    this.settings = response.body.data.global_settings;
                    if (this.isEncrypted) {
                        this.queryData("M", {id: "all", module: "all"}, new Date().getFullYear(), "");
                    } else {
                        this.queryData("M", -1, new Date().getFullYear(), "");
                    }
                } else {
                    window.location = Redirect_500;
                }
            },
            responseOkFetch(response) {
                this.hideLoader();
                this.$refs.auftraegeTable.currentPage = 1;
                this.$refs.searchBar.onFirstSearch();

                if (response.status === 200 && response.body.status === "ok") {
                    this.data = response.body.data;
                } else {
                    window.location = Redirect_500;
                }
            },
            responseError(response) {
                this.hideLoader();
                if (response.status === 401) {
                    window.location = Redirect_Login;
                } else {
                    window.location = Redirect_500;
                }
            },
            queryData(typ, group, year, searchText, count, augr) {
                let module = "";
                if (this.isEncrypted) {
                    module = group.module;
                    group = group.id;
                }
                this.showLoader();
                this.$http.get(
                    Server_URL+'/auftragsbuch/data/fetch/'+group+
                    "?search_typ="+typ+
                    "&search_text="+searchText+
                    "&year="+year+
                    "&count="+count+
                    "&group="+augr+
                    "&offen=0"+ "&module=" + module
                ).then(this.responseOkFetch, this.responseError)
            }
        },
    }
</script>

<style scoped>

</style>
